import React from "react";
import { Box, Typography } from "@mui/material";
import DateTimeSelect from "./DateTimeSelect";

const DateRangeSelect = ({ startDate, endDate, onChange }) => {
  const today = new Date().toISOString().slice(0, 10);

  const handleStart = (val) => {
    // If no end date yet, default to today; if new start is after current end, reset end to today
    let nextEnd = endDate;
    if (!nextEnd) nextEnd = today;
    else if (val && val > nextEnd) nextEnd = today;
    onChange({ startDate: val, endDate: nextEnd });
  };

  const handleEnd = (val) => {
    // If new end is before current start, clear start
    const nextStart = startDate && val && val < startDate ? null : startDate;
    onChange({ startDate: nextStart, endDate: val });
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <Box sx={{ width: 148 }}>
        <DateTimeSelect
          value={startDate || ""}
          onChange={handleStart}
          placeholder="Start date"
          dateOnly
        />
      </Box>
      <Typography sx={{ fontSize: 12, color: "hsl(150 10% 46%)", flexShrink: 0, userSelect: "none" }}>
        →
      </Typography>
      <Box sx={{ width: 148 }}>
        <DateTimeSelect
          value={endDate || ""}
          onChange={handleEnd}
          placeholder="End date"
          dateOnly
        />
      </Box>
    </Box>
  );
};

export default DateRangeSelect;
